import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import Testimonial from '../components/Testimonial'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="學術研究" />

    <div
      className="bg-center bg-cover py-12 md:bg-center-x-40p lg:bg-center"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-research.jpg)` }}
      id="leading-research-institute"
    >
      <div className="container" style={{ minHeight: 500 + 'px' }} data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
        <Bubble className="w-full md:w-2/3 lg:w-1/2"
          title="學術研究的權威機構"
          subtitle=""
        >
          <div className="text-justify">
            <p className="mb-4">旅遊學院的研究涵蓋從旅遊接待能力到人力資源研究的領域，並以全球旅遊業發展為背景，致力開展具影響力的學術研究，以及將學院發展成為亞洲領先的旅遊研究中心。學院通過各種研究合作項目與世界知名大學合作，共享知識，共同開展先進和高質量的研究課題。</p>
            <p>旅遊學院堅信在匯聚世界各地優秀人才的參與，以及在學術人員之間的協作和機構間的多方位合作之下，學術研究水平會越來越高，研究成果會更加豐碩，必將為全球的旅遊及酒店業帶來重大影響。</p>
          </div>
        </Bubble>
      </div>
    </div>

    <div className="py-8 md:py-12" id="international-conferences">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down" data-aos-delay={850}>列席國際性會議</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3 flex">
            <div className="inset-0" data-aos="fade-right">
              <img src="/AnnualReport2017-2018/images/research/4.1.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex mt-4 lg:mt-0" data-aos="fade-left">
            <div className="text-left mx-auto text-sm md:text-base pl-0 lg:pl-8 font-normal text-justify">
              <p className="mb-4">作為旅遊和酒店業研究機構的成員之一，旅遊學院經常派員參加國際會議。同時也在澳門及外地組織國際會議，旨在為行業精英和高水平的研究人員提供溝通及交流的平台。</p>
              <p>2017年12月12日至14日，旅遊學院作為合辦機構，與美國佛羅里達大學Rosen College of Hospitality Management及英國波恩茅斯大學合辦“第四屆會展及節目國際學術會議”（ICE2017）。會議吸引來自13個國家和地區的65位代表出席，包括Abraham Pizam教授、Fevzi Okumus教授、Donald Getz教授、Rhodri Thomas教授、Judith Mair教授和Alan Fyall教授等世界知名學者擔任會議的主講嘉賓。旅遊業研究暨科研中心主任李力東教授（Professor Leonardo Dioko教授）和ICE2017組織委員會成員Ubaldino Couto講師帶領學院的Laurie Baker-Malungu博士、崔瑞希副教授和譚秀嫦講師組成了五人代表團一同與會。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="policy-research">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">政策研究</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/2 flex" data-aos="fade-right">
            <div className="text-left mx-auto text-sm md:text-base lg:pl-8 font-normal text-justify">
              <p className="mb-4">旅遊學院旅遊業研究暨科研中心長期以來收集澳門特別行政區和鄰近地區與旅業和酒店業相關的資料進行研究和分析，並將研究結果反饋給政府和業界。該中心作為公共政策智庫力量之一，向澳門政府各個部門提供顧問服務，並與國外研究夥伴進行廣泛合作，令研究更加國際化。</p>
              <p className="mb-4">不少澳門旅遊業相關的指標也會從中心各項研究中總結得出，包括定期公佈訪澳旅客滿意度指標及訪澳旅客分析報告。這些研究為旅遊業管理人員提供了寶貴的資料。</p>
              <p>旅遊及酒店業人力資源亦是中心的研究範疇之一，澳門人力資源監察調查研究是一個長期研究項目，旨在評估酒店、博彩及旅遊業從業人員的態度、工作滿意度和意見。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
            <div className="lg:pl-8">
              <div data-aos="zoom-out" data-aos-delay={150}>
                <Testimonial
                  title="旅遊學院於2017/18進行了下列政策研究："
                  color="orange"
                >
                  <p>澳門旅遊接待能力研究 Macao Tourism Carrying Capacity</p>
                  <p>訪澳旅客滿意度指標 Macao Tourist Satisfaction Index</p>
                  <p>訪澳旅客分析報告 Visitor Profile Survey</p>
                  <p>澳門人力資源監察調查 Macao Human Resource Monitoring Survey</p>
                </Testimonial>
              </div>

              <div data-aos="zoom-out" data-aos-delay={300}>
                <Testimonial
                  title="2017/18學年應用研究及行業諮詢機構："
                  color="blue"
                  className="mt-8"
                >
                  澳門酒店協會
                </Testimonial>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
